export default __webpack_public_path__ + "static/media/205.a2727128.png";